import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
        <path
            fill={props.fill ?? 'currentColor'}
            d="M5.2 13.6c-.33 0-.613-.117-.848-.352A1.156 1.156 0 0 1 4 12.4v-8h-.2a.6.6 0 1 1 0-1.2h2.6a.8.8 0 0 1 .8-.8h1.6a.8.8 0 0 1 .8.8h2.6a.6.6 0 0 1 0 1.2H12v7.993c0 .338-.117.624-.352.857a1.16 1.16 0 0 1-.848.35H5.2Zm5.6-9.2H5.2v8h5.6v-8Zm-4.4 6.2a.6.6 0 1 0 1.2 0V6.2a.6.6 0 0 0-1.2 0v4.4Zm2 0a.6.6 0 1 0 1.2 0V6.2a.6.6 0 0 0-1.2 0v4.4Z"
        />
    </svg>
);
export { SvgComponent as Delete };
